<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-lx-profile"></i> 管理员</el-breadcrumb-item>
                <el-breadcrumb-item>人员列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class='container' style='min-width: 900px'>
            <div class="hovertable">
                <el-table
                :data="table.tableData"
                class="table"
                type="index"
                v-loading="table.loading"
                ref="multipleTable"
                :cell-style="{ textAlign: 'center' }"
                :header-cell-style="{textAlign: 'center'}"
                header-cell-class-name="table-header"
                @cell-click="rowClick"
                >
                    <el-table-column prop="userId" label="ID" align="center" width="340"></el-table-column>
                    <el-table-column prop="nickName" label="Nickname"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="{row}">
                            <el-button
                            size="mini"
                            type="danger"
                            @click="handleDelete(row.userId)">Delete</el-button>
                        </template>
                    </el-table-column>

                </el-table>
            </div>
            
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="table.pageIndex"
                    :page-size="table.pageSize"
                    :total="table.pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { logicDelInnerUser, selInnerMemberByCondition } from '../../api/role.js';

export default {
    name: 'Role',
    data() {
        return {
            table: {
                tableData: [], // el-table集合
                pageIndex: 1,  // 页码
                pageTotal: 0,  // 总数据量
                pageSize: 0,   // 单页数据量
                loading: false // 加载动画
            }
        };
    },
    created() {
        this.getData()
    },
    activated() {
        this.getData()
    },
    methods: {
        // 分页获取所有数据
        getData() {
            // operartion:   1.查询未分配职位人员、2.按项目查询所有人员、3.按账号查询所有已分配职位人员
            // condition:   条件为 账号
            this.table.loading = true
            
            let params = { 'startPage': (this.table.pageIndex - 1) * 15, 'pageCount': this.table.pageIndex * 15 };
            selInnerMemberByCondition(params).then(res => {
                this.table.tableData = res.data.data

                // 将 RoleId 替换成 未分配
                this.table.tableData.forEach(item => {
                    item.roleId = '未分配'
                })

                this.table.pageTotal = this.table.tableData[0].count
                this.table.pageSize = 15    // 单页数据量
                this.table.loading = false
            }).catch(error => {
                console.log(error)
            })
        },
        
        // 逻辑删除
        handleDelete(userId) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                let params = {'userId' : userId}
                logicDelInnerUser(params).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message)
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            })
        },

        // row点击 进入详细职能管理页面
        rowClick(row, column) {
            if (column.label != '操作') {
                // 获取人员最后登录时间
                let loginTime = '暂未登录'
                if (row.loginTime != undefined) loginTime = moment(row.loginTime).format("YYYY-MM-DD HH:mm:ss")
                // 保存参数
                let str = {'nickName': row.nickName, 'userId': row.userId, 'loginTime': loginTime}
                localStorage.setItem('roleRow', JSON.stringify(str))
                setTimeout(() => {
                    this.$router.push('/position');
                }, 100);
            }
        },

        // 分页导航
        handlePageChange(val) {
            this.table.pageIndex = val
            this.getData();
        },
    }
};
</script>

<style scoped lang="scss">
    .table {
        width: 100%;
        font-size: 14px;
        border-radius: 5px;
    }
</style>
